import { TicketReplyType, userType } from "../../DTO";
import { Api } from "../api";

export const ReplyTicket = (
    user: userType,
    ticketId: number | string,
    reply: string,
) => {
    return new Promise<{ reply: TicketReplyType }>((resolve, reject) => {
        const api = new Api({
            method: "post",
            path: `tickets/${ticketId}/reply`,
            header: {
                Authorization: `Bearer ${user.access_token}`,
            },
            body: {
                reply,
            },
        });

        return api
            .call()
            .then((data: any) => resolve({ reply: data.data }))
            .catch((err: any) => reject(err?.data?.message ?? err));
    });
};
